<template>
	<section class="newsletter-section background-light">
		<div class="row">
			<div class="columns column6">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column6">
				<div id="mc_embed_shell">
					<div id="mc_embed_signup">
						<form
							id="mc-embedded-subscribe-form"
							action="https://altenbroek.us20.list-manage.com/subscribe/post?u=b521529c4c6438a654a58038b&id=cf35b41679&f_id=00e776eef0"
							method="post"
							name="mc-embedded-subscribe-form"
							class="validate newsletter"
							target="self"
							novalidate=""
						>
							<div id="mc_embed_signup_scroll">
								<div class="mc-field-group">
									<input
										id="mce-EMAIL"
										type="email"
										name="EMAIL"
										class="required email"
										required=""
										value=""
										:placeholder="$t('formEmail')"
									/>
									<input
										id="mc-embedded-subscribe"
										type="submit"
										name="subscribe"
										class="button cta button-cta"
										:value="button"
									/>
								</div>
								<div id="mce-responses" class="clear foot">
									<div id="mce-error-response" class="response" style="display: none"></div>
									<div id="mce-success-response" class="response" style="display: none"></div>
								</div>
								<div aria-hidden="true" style="position: absolute; left: -5000px">
									<input
										type="text"
										name="b_b521529c4c6438a654a58038b_cf35b41679"
										tabindex="-1"
										:value="button"
									/>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 60px 0;
	margin: 0;
	border-bottom: none;

	h2,
	h3 {
		margin: 0 0 20px;
	}

	form {
		margin-top: 30px;
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: flex-start;
		gap: 10px;

		input {
			background: var(--primary-background-color);
			padding: 15px;
			height: 52px;
			border: none;
			width: 48%;
			max-width: 300px;
			vertical-align: top;

			&::placeholder {
				color: #333;
			}

			&.button {
				line-height: 22px;
				margin: 0;
				width: auto;
				padding: 14px 30px;
				background: #000;
				color: #fff;
				max-width: 200px;

				&:hover {
					background: #111;
					color: #fff;
				}
			}
		}
	}
}
</style>
